if (!customElements.get('product-modal')) {
    customElements.define(
        'product-modal',
        class ProductModal extends ModalDialog {
            constructor() {
                super();
                this.isZoomed = false; // Track the zoom state
            }

            hide() {
                super.hide();
            }

            show(opener) {
                super.show(opener);
                this.showActiveMedia();
            }

            showActiveMedia() {
                this.querySelectorAll(
                    `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
                ).forEach((element) => {
                    element.classList.remove('active');
                });
                const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
                const activeMediaTemplate = activeMedia.querySelector('template');
                const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
                activeMedia.classList.add('active');
                activeMedia.scrollIntoView();

                const container = this.querySelector('[role="document"]');
                container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

                if (
                    activeMedia.nodeName == 'DEFERRED-MEDIA' &&
                    activeMediaContent &&
                    activeMediaContent.querySelector('.js-youtube')
                ) {
                    activeMedia.loadContent();
                }

                // Add toggle zoom functionality to the active image
                activeMedia.addEventListener('click', () => {
                    if (this.isZoomed) {
                        activeMedia.style.transform = 'scale(1)';
                        this.isZoomed = false;
                    } else {
                        activeMedia.style.transform = 'scale(2)';
                        this.isZoomed = true;
                    }
                    activeMedia.style.transition = 'transform 0.3s ease';
                });

                // Reset zoom on modal close
                this.addEventListener('hide.bs.modal', () => {
                    activeMedia.style.transform = 'scale(1)';
                    activeMedia.style.transition = 'none';
                    this.isZoomed = false;
                });
            }
        }
    );
}
